<template>
	<div class="profile">
		<img
			:src="imgProfile"
			:alt="user.data.displayName"
			class="profile-img"
			@click="toggleProfileMenu"
		/>
		<div v-if="isShowProfileMenu" class="profile-overlay">
			<div class="profile-menu" v-click-outside="clickOutside">
				<div class="top">
					<img :src="imgProfile" :alt="user.data.displayName" />
					<div class="info">
						<div class="name">
							{{
								$t("LoginMenuTextUsername", {
									GmailUserName: user.data.displayName,
								})
							}}
						</div>
						<div class="email">
							{{
								$t("LoginMenuTextUserEmail", {
									GmailEmail: user.data.email,
								})
							}}
						</div>
					</div>
				</div>
				<ul class="items">
					<li class="item">
						<router-link
							:to="$t('LoginMenuUrlSavedWords')"
							:title="$t('LoginMenuTitleAttributeSavedWords')"
							@click.native="onSavedWordsClick"
							class="item-link"
						>
							<span class="icon wficon-heart-login"></span>
							{{ $t("LoginMenuTextSavedWords") }}
						</router-link>
					</li>
					<li>
						<a
							href="#"
							:title="$t('LoginMenuTitleAttributeSignOut')"
							@click.prevent="onLogout"
							class="item-link"
						>
							<span class="icon wficon-logout"></span>
							{{ $t("LoginMenuTextSignOut") }}
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
	name: "Profile",
	data() {
		return {
			isShowProfileMenu: false,
		};
	},
	props: {
		user: {
			type: Object,
			required: true,
		},
		imgProfile: {
			type: String,
			required: true,
		},
	},
	methods: {
		toggleProfileMenu() {
			this.isShowProfileMenu = !this.isShowProfileMenu;

			if (!this.isSmallDevice) return;
			const body = document.getElementsByTagName("body")[0];
			this.isShowProfileMenu
				? (body.style.overflow = "hidden")
				: (body.style.overflow = null);
		},
		clickOutside(e) {
			if (e.toElement.className === "profile-img") return;
			this.toggleProfileMenu();
		},
		onLogout() {
			this.$emit("logout");
			this.toggleProfileMenu();

			this.$store.dispatch("trackEvent", {
				ga: this.$ga,
				eventCategory: "Login",
				eventAction: "Click on sign out menu section",
				eventLabel: "LoginMenuTextSignOut",
				eventID: 44,
			});
		},
		onSavedWordsClick() {
			this.toggleProfileMenu();

			this.$store.dispatch("trackEvent", {
				ga: this.$ga,
				eventCategory: "Login",
				eventAction: "Click on save words menu section",
				eventLabel: "LoginMenuTextSavedWords",
				eventID: 42,
			});
		},
	},
	directives: {
		ClickOutside,
	},
};
</script>
<style lang="scss" src="./styles.scss" scoped></style>
